<template>
  <div>
    <Layout
      username="Administrator"
      current-page="Companies"
      link-to-edit="/admin-dashboard/edit-profile"
    >
      <template slot="menuItems">
        <li v-for="{ title, icon, path } in menu" :key="title" class="nav-item">
          <MenuItems :menu-item="title" :icon-menu="icon" :to-where="path" />
        </li>
      </template>
      <template slot="side info">
        <!-- <div class="d-flex">
          Generate report<i class="fa fa-lg fa-file-pdf ml-2 text-danger" /><i
            class="fa fa-lg fa-file-excel ml-2 text-success"
          />
        </div> -->
      </template>
      <template slot="messages">
        <div
          v-if="alert.message"
          :class="`alert ${alert.type} alert-dismissible fade show`"
          role="alert"
        >
          {{ alert.message }}
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
      <template slot="content">
        <div class="jumbotron">
          <form class="form-inline">
            <label class="sr-only" for="inlineFormInputName2">Name</label>
            <input
              id="inlineFormInputName2"
              v-model="searchQuery"
              type="text"
              class="form-control mb-2 mr-sm-2"
              placeholder="Type to search..."
              @input="onQueryChange"
            />
            <button type="reset" class="btn btn-secondary mb-2 btn-sm">
              Clear
            </button>
          </form>
          <a-table
            :columns="columns"
            :data-source="Object.values(companies.data)"
          >
            <a slot="name" slot-scope="text">{{ text }}</a>
            <span slot="customTitle"><a-icon type="smile-o" /> Name</span>
            <span slot="tags" slot-scope="tags">
              <a-tag
                v-for="tag in tags"
                :key="tag"
                :color="
                  tag === 'loser'
                    ? 'volcano'
                    : tag.length > 5
                    ? 'geekblue'
                    : 'green'
                "
              >
                {{ tag.toUpperCase() }}
              </a-tag>
            </span>
            <span slot="action" slot-scope="text, record">
              <a-button @click="toCompany(record)"> View </a-button>
              <a-divider type="vertical" class="mx-2" />
              <a-button type="primary" @click="handleDelete(record)"
                >Edit</a-button
              >
            </span>
          </a-table>
          <!-- 
          <pagination
            :pages="companies.pages"
            :on-paginate="onPaginate"
            :current-page="currentPage"
          /> -->
        </div>
      </template>
    </Layout>
  </div>
</template>

<script>
import Layout from "../../../components/Layout";
import MenuItems from "../../../components/MenuItems";
import { mapGetters } from "vuex";
const columns = [
  {
    dataIndex: "name",
    key: "name",
    title: "Company Name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Phone Contact",
    key: "phoneNumber",
    dataIndex: "phoneNumber",
  },
  {
    title: "Action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

export default {
  name: "Adminreports",
  components: {
    Layout,
    MenuItems,
    // Pagination,
  },
  data() {
    return {
      columns,
      pageSize: 100,
      currentPage: 1,
      timer: null,
      menu: [
        {
          title: "Dashboard",
          icon: "fa fa-chart-line",
          path: "/admin",
        },
        {
          title: "Add Company",
          icon: "fa fa-plus",
          path: "/admin/companies/new",
        },
        {
          title: "Companies",
          icon: "fa fa-table",
          path: "/admin/companies",
        },
        {
          title: "Sales",
          icon: "fa fa-table",
          path: "/admin/admin-sales",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({ companies: "admin/getAllCompanies" }),
    alert() {
      return this.$store.state.alert;
    },
  },
  mounted() {
    this.getReport();
  },
  methods: {
    getReport() {
      this.$store
        .dispatch("admin/reports", {
          page: this.currentPage,
          limit: this.pageSize,
        })
        .then(() => (this.getting = true));
    },
    onQueryChange() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.currentPage = 1;
        this.$store.dispatch("admin/reports", {
          search: this.searchQuery,
          page: this.currentPage,
          limit: this.pageSize,
        });
      }, 500);
    },
    onPaginate(value) {
      if (value > 0 && value < this.companies.pages + 1) {
        this.currentPage = value;
        this.getReport();
      }
    },
    toCompany(company) {
      return this.$router.push({
        path: `/admin/companies/${company.id}`,
        query: {
          company: company.name,
        },
      });
    },
    handleDelete(company) {
      return this.$router.push({
        path: `/admin/companies/${company.id}/edit`,
      });
    },
  },
};
</script>

<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}
.nav-item.active {
  background: #faffe1;
}
.jumbotron {
  overflow-x: scroll;
}
.company-item {
  cursor: pointer;
}
</style>
